<script>
  import currentUser from '../stores/auth';
  import {Link, navigate} from "svelte-routing";
  import supabase from '../db'

  let isLogging = false;

  let emailEl;
  let email = null;
  let emailErrorMsg = "Please enter correct email";;

  let passwordEl;
  let password;
  let passworddErrorMsg = "Please enter your password";

  async function login() {
    emailErrorMsg = 'Please enter correct email';
    passworddErrorMsg = "Please enter your password";

    if (emailEl) emailEl.setCustomValidity("");
    if (passwordEl) emailEl.setCustomValidity("");

    if (!emailEl || !emailEl.checkValidity() || !passwordEl || !passwordEl.checkValidity()) return false;

    try {
      isLogging = true;

      const {error: dbError} = await supabase.auth.signIn({email, password})

      if (dbError) {
        emailErrorMsg = dbError.message;
        if (emailEl) emailEl.setCustomValidity(emailErrorMsg);

        return false;
      }


      isLogging = false;
    } catch {
      emailErrorMsg = "Unknown error has occurred";

      isLogging = false;
    }

    return false;
  }

  function redirectIfNeeded(user) {
    if (user) navigate(`/projects`);
  }

  $: redirectIfNeeded($currentUser)
</script>

<section class="nes-container is-dark is-rounded with-title">
  <h2 class="title">Login</h2>
  <section class="form">
    <div class="nes-field">
      <label for="email">Email</label>
      <input type="email" id="email" class="nes-input is-dark"
             required bind:this={emailEl} bind:value={email}
      >
      <div class="nes-text is-error">{emailErrorMsg}</div>
    </div>

    <div class="nes-field">
      <label for="password">Password</label>
      <input type="password" id="password" class="nes-input is-dark"
             required bind:this={passwordEl} bind:value={password}
      >
      <div class="nes-text is-error">{passworddErrorMsg}</div>
    </div>

    <button type="button" class={`nes-btn ${isLogging ? 'is-disabled' : 'is-primary'}`} on:click={login}
            class:disabled={isLogging}>Login</button>
    <Link to="/password-reset">Password reset</Link>
  </section>
</section>

<style>
    .form {
        margin: 0 auto;
        max-width: 30rem;
    }

    .form .nes-field {
        margin-bottom: 1.5rem;
    }

    input:valid + .nes-text {
        display: none
    }

    input:invalid + .nes-text {
        display: block;
    }

    .is-error {
        margin-top: .5rem;
    }
</style>